
// import { MessageDialog } from '../../framework/frontend/MessageDialog';
import { defineComponent, reactive } from "vue";
const defaultId = "myModal";

export default defineComponent({
  props: {
    title: {
      type: String,
      default: "my dialog",
    },
    id: {
      type: String,
      default: defaultId,
    },
    dialogClass: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  emits: ["close"],
  setup: (prop, context) => {
    const props = reactive(prop);
    return {
      props,
      context,
    };
  },
});
